import React, { createContext, useContext, useState, useEffect } from 'react';
import ControlButton from '../ui/ControlButton';
import { usePlayerContext } from '../Context';
import { StateChangedEvents } from '../../sdk/PlayerEvents';
import { Events, State } from '../../types/player';

const SeekControlRewind = () => {
  const { sdk } = usePlayerContext();

  const [seekControlInterval, setSeekControlInterval] = useState(
    sdk.getSeekControlInterval() as number,
  );

  useEffect(() => {
    sdk.on(Events.SEEK_CONTROL_INTERVAL_CHANGED, (value: number) => {
      setSeekControlInterval(value);
    });
  }, []);

  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-seek-rewind`}
    >
      <ControlButton
        className={'seek-rewind'}
        icon={'arrowRotateLeft'}
        handleAction={() => {
          sdk.seekRewind();
        }}
        title={'Rewind'}
      />
    </div>
  );
};

export default SeekControlRewind;
